import React from "react";
import Card from "@mui/material/Card";
import globalClasses from "../../css/Global.module.css";

const CommonCard = (props:any) => {
return(
    <Card className={globalClasses.card}>
        {props.children}
    </Card>
)
}

export default CommonCard;